<svg [attr.height]="radius * 2" [attr.width]="radius * 2">
    <g>
        <circle
            [attr.stroke-dasharray]="circumference + ' ' + circumference"
            [attr.style]="{ stroke: secondary, strokeDashoffset: 0 }"
            [attr.stroke-width]="stroke"
            fill="transparent"
            [attr.r]="normalizedRadius"
            [attr.cx]="radius"
            [attr.cy]="radius"
        />
        <circle
            [attr.stroke-dasharray]="circumference + ' ' + circumference"
            [attr.style]="{ stroke: primary, strokeDashoffset: strokeDashoffset }"
            [attr.stroke-width]="stroke"
            fill="transparent"
            [attr.r]="normalizedRadius"
            [attr.cx]="radius"
            [attr.cy]="radius"
        />
        <text
            dominant-baseline="middle"
            text-anchor="middle"
            [attr.x]="radius"
            [attr.y]="radius"
            [attr.style]="{ color: 'var(--text-color)', fontSize: 'var(--text-xs)', fontWeight: 'var(--text-bold)' }"
        >
            {{ progress }}%
        </text>
    </g>
</svg>
